const translations = {
  no: "Discard",
  yes: "Keep"
};

export default translations;
